import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import GridSelectorInput from '../../../../../../components/controls/GridSelectorInput';
import GridWrapper from '../../../../../../components/controls/GridWrapper';
import { TextInput } from '../../../../../../components/controls/inputs';
import { BaseModalWindow } from '../../../../../../components/modalWindows/BaseModalWindow'
import styles from '../../../../../../components/modalWindows/styles/BaseModalWindow.module.scss'
import { IEntitySimpleDTO } from '../../../../../../libs/coreapi-dto/@types/common';
import { ICreateUser, IUserViewDTO } from '../../../../../../libs/coreapi-dto/service/user';
import { useForm } from '../../../../../../system/hooks/useForm';
import { useAppContext } from '../../../../../../system/providers/appContextProvider';
import CompaniesSelectorModal from '../../../../Companies/CompaniesSelectorModal';
import userModalStyles from '../styles/UserModal.module.scss'
import { CompanyDataProvider } from '../../../../../../Services/DataProviders/CompanyDataProvider';
import buffer from "buffer";
import { Spinner } from '../../../../../../components/spiner/Spinner';
import DefaultPluginSettingsSelectorModal from '../../../../DefaultPluginSettings/DefaultPluginSettingsSelectorModal';
import { UserDefaultDto } from '../../../../../../libs/coreapi-dto/service/pluginSettingType';

export type TypeOpen = 'Create' | 'Edit'

type IDictionaryType = 'userGrid' | 'userLocalGrid'

type Validator = ICreateUser

interface ICreateUserModalProps {
    ok: (userData: ICreateUser) => void
    data: any
    selectedItem?: IGridRow
    dataProvider: any
    cancel: () => void
    typeOpen: TypeOpen
    dictionaryType: IDictionaryType
    disableCompany?: boolean
    baseCompanyName?: string
    lockFromPermission?: boolean
}

export const CreateUserModal: FC<ICreateUserModalProps> = (props) => {
    const initialUserData: ICreateUser = {
        idGlobal: '',
        companyId: '',
        fullName: '',
        shortName: '',
        password: '',
        phoneNumber: '',
        email: '',
        username: '',
        position: ''
    };
    const appCtx = useAppContext();
    const [userData, setUserData] = useState<ICreateUser>(initialUserData);
    const [company, setCompany] = useState<IEntitySimpleDTO>();
    const [pluginSettingType, setPluginSettingType] = useState<IEntitySimpleDTO>();
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();
    const errorsT = (value: string) => t('login.help.' + value);
    const cdp = new CompanyDataProvider(appCtx.coreApiService);

    const [password, setPassword] = useState<string>('')

    useEffect(() => {
        if (props.typeOpen === 'Edit' && props.selectedItem) {
            setIsLoading(true);
            if (props.dictionaryType === 'userGrid') {
                props.dataProvider.getUserById(props.selectedItem?.idGlobal, (entities) => {
                    getUserData(entities);
                    setIsLoading(false);
                });
            } else if (props.dictionaryType === 'userLocalGrid') {
                props.dataProvider.getById(props.selectedItem?.idGlobal, (entities) => {
                    setPluginSettingType({idGlobal: entities.idPluginSettingTypeGlobal, displayName: entities.pluginSettingTypeName})
                    getUserData(entities);
                    setIsLoading(false);
                });
            }
        }

        if (props.typeOpen === 'Create' && props.baseCompanyName) {
            setIsLoading(true);
            cdp.getAllCompany((e) => {
                let company = e.find(x => x.name === props.baseCompanyName);
                let entity = { displayName: company?.name, idGlobal: company?.id } as IEntitySimpleDTO;
                setUserData(prev => ({ ...prev, companyId: company?.id ?? '' }));
                setCompany(entity);
                setIsLoading(false);
            });
        }
    }, [props.selectedItem, props.typeOpen, props.baseCompanyName])

    function getUserData(entities) {
        cdp.getAllCompany((e) => {
            let company = props.dictionaryType === 'userLocalGrid' ? 
                e.find(x => x.id === props.data.find(i => i.idGlobal === props?.selectedItem?.idGlobal)?.companyId) : 
                e.find(x => x.name === props.data.find(i => i.id === props?.selectedItem?.idGlobal)?.companyName);
            let entity = { displayName: company?.name, idGlobal: company?.id } as IEntitySimpleDTO;
            setUserData({
                idGlobal: entities?.idGlobal ?? '',
                companyId: company?.id ?? '',
                fullName: entities.fullName || '',
                shortName: entities.shortName || '',
                password: '',
                phoneNumber: entities.phoneNumber || '',
                idPluginSettingTypeGlobal: entities.idPluginSettingTypeGlobal || '',
                pluginSettingTypeName: entities.pluginSettingTypeName || '',
                email: entities.email || '',
                username: entities.userName || '',
                position: entities.position || ''
            });
            setCompany(entity);
        });
    }

    const { isValid, errors, setErrors } = useForm<Validator>({
        validations: {
            fullName: {
                required: {
                    value: userData.fullName ? false : true,
                    message: errorsT("fullName"),
                },
            },
            shortName: {
                required: {
                    value: userData.shortName ? false : true,
                    message: errorsT("shortName"),
                },
            },
            phoneNumber: {
                required: {
                    value: userData.phoneNumber?.match(/^([0-9]){11}$/) || !userData.phoneNumber ? false : true,
                    message: errorsT("phoneNumber"),
                },
            },
            password: {
                custom: {
                    isValid: (value) => {
                        if (props.typeOpen === 'Edit') return true
                        let ru = /[а-яА-ЯёЁ]+/i.test(password);
                        return RegExp(/^.*(?=.{3,})(?=.*[a-zA-Z])(?=.*\d).*$/).test(password) && !ru;
                    },
                    message: errorsT("password"),
                },
            },
            email: {
                required: {
                    value: userData.email?.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) || !userData.email ? false : true,
                    message: errorsT("email"),
                },
            },
            username: {
                required: {
                    value: userData.username?.match(/^([a-zA-Z/0-9/_]){5,}$/) ? false : true,
                    message: errorsT("userName"),
                },
            },
            companyId: {
                required: {
                    value: userData.companyId ? false : true,
                    message: errorsT("required"),
                },
            }
        },

    });

    var a = {"Ё":"YO","Й":"I","Ц":"TS","У":"U","К":"K","Е":"E","Н":"N","Г":"G","Ш":"SH","Щ":"SCH","З":"Z","Х":"H","Ъ":"'","ё":"yo","й":"i","ц":"ts","у":"u","к":"k","е":"e","н":"n","г":"g","ш":"sh","щ":"sch","з":"z","х":"h","ъ":"'","Ф":"F","Ы":"I","В":"V","А":"A","П":"P","Р":"R","О":"O","Л":"L","Д":"D","Ж":"ZH","Э":"E","ф":"f","ы":"i","в":"v","а":"a","п":"p","р":"r","о":"o","л":"l","д":"d","ж":"zh","э":"e","Я":"Ya","Ч":"CH","С":"S","М":"M","И":"I","Т":"T","Ь":"'","Б":"B","Ю":"YU","я":"ya","ч":"ch","с":"s","м":"m","и":"i","т":"t","ь":"'","б":"b","ю":"yu"};
    function transliterate(word){
    return word.split('').map(function (char) {
        return a[char] || char;
    }).join("");
    }

    function onChangeFullFIO(e) {
        let login = transliterate(e.split(' ')[0]);
        setUserData({ ...userData, fullName: e, username: login })
    }

    function onChangePassword(e) {
        setPassword(e);
        let hash = buffer.Buffer.from(e, 'utf-8').toString("base64");
        setUserData({ ...userData, password: hash })
    }

    const setUserDefaultProfile = () => {
        const model = {
            idPluginSettingTypeGlobal: pluginSettingType?.idGlobal, idUserGlobal: userData.idGlobal, isAssigned: pluginSettingType ? true: false
        } as UserDefaultDto
        appCtx.uiApiService.uiDefaultPluginSettingsRequest.setUserDefaultProfile(model)
    }

    return (
        <BaseModalWindow
            header={props.typeOpen === 'Create' ? "Создание пользователя" : "Редактирование пользователя"}
            ok={{
                onClick: () => {
                    if (isValid()) {
                        setUserDefaultProfile()
                        props.ok(userData)
                    }
                },
                title: "Сохранить и закрыть",
                disabled: props.lockFromPermission || isLoading
            }}
            cancel={{ onClick: () => props.cancel(), title: "Закрыть без  сохранения" }}
            modalWindowClassName={styles.modalWindowSmallBase}
            footerStyle='customStyles'
        >
            {isLoading ? (
                <Spinner />
            ) : (
                    <GridWrapper cols={2} className={styles.gridContainer}>
                        <TextInput
                            label='Полное ФИО'
                            onChange={(e) => onChangeFullFIO(e)}
                            value={userData.fullName}
                            placeholder='Иванов Иван Иванович'
                            error={errors.fullName}
                            onFocus={() => setErrors({ ...errors, fullName: undefined })}
                            required
                            disabled={props.lockFromPermission}
                            isExternalValue
                        />
                        <TextInput
                            label='ФИО'
                            onChange={(e) => setUserData({ ...userData, shortName: e })}
                            value={userData.shortName}
                            placeholder='Иванов.И.И'
                            error={errors.shortName}
                            onFocus={() => setErrors({ ...errors, shortName: undefined })}
                            required
                            disabled={props.lockFromPermission}
                            isExternalValue
                        />
                        <TextInput
                            label='Email'
                            onChange={e => { setUserData({ ...userData, email: e }) }}
                            value={userData.email}
                            placeholder='Invanov@email.com'
                            type='email'
                            error={errors.email}
                            onFocus={() => setErrors({ ...errors, email: undefined })}
                            disabled={props.lockFromPermission}
                            isExternalValue
                        />
                        <TextInput
                            label='Номер телефона'
                            onChange={e => setUserData({ ...userData, phoneNumber: e })}
                            value={userData.phoneNumber}
                            type='number'
                            placeholder='79977334495'
                            pattern='[789][0-9]{9}'
                            error={errors.phoneNumber}
                            onFocus={() => setErrors({ ...errors, phoneNumber: undefined })}
                            disabled={props.lockFromPermission}
                            isExternalValue
                        />
                        <TextInput
                            label='Логин'
                            onChange={e => setUserData({ ...userData, username: e })}
                            value={userData.username}
                            placeholder='IvanovIN'
                            error={errors.username}
                            onFocus={() => setErrors({ ...errors, username: undefined })}
                            required
                            disabled={props.lockFromPermission}
                        />
                        <TextInput
                            placeholder={props.typeOpen === 'Edit' ? '**********' : undefined}
                            label='Пароль'
                            onChange={e => onChangePassword(e) }
                            value={password}
                            type='password'
                            error={errors.password}
                            onFocus={() => setErrors({ ...errors, password: undefined })}
                            required={props.typeOpen === 'Edit' ? false: true}
                            disabled={props.lockFromPermission}
                        />
                         <TextInput
                            label='Должность'
                            onChange={e => setUserData({ ...userData, position: e })}
                            value={userData.position}
                            disabled={props.lockFromPermission}
                        />
                        <GridSelectorInput
                            className={userModalStyles.field_Company}
                            id='idCompanyGlobal'
                            label='Компания'
                            selectedEntity={company}
                            onSelect={e => {
                                setUserData({ ...userData, companyId: e?.idGlobal })
                                setCompany(e)
                            }}
                            selectorModalJsx={CompaniesSelectorModal}
                            error={errors.companyId}
                            onFocus={() => setErrors({ ...errors, companyId: undefined })}
                            disabled = {(props.disableCompany ?? false) || props.lockFromPermission}
                        />
                        <GridSelectorInput
                            className={userModalStyles.field_Company}
                            id='idPluginSettingType'
                            label='Настройки интерфейса'
                            selectedEntity={pluginSettingType}
                            onClear={() => {
                                setUserData({ ...userData, idPluginSettingTypeGlobal: undefined, pluginSettingTypeName: undefined })
                                setPluginSettingType(undefined)
                            }}
                            onSelect={e => {
                                setUserData({ ...userData, idPluginSettingTypeGlobal: e?.idGlobal, pluginSettingTypeName: e?.displayName })
                                setPluginSettingType(e)
                            }}
                            selectorModalJsx={DefaultPluginSettingsSelectorModal}
                        />
                    </GridWrapper>
                )
            }
        </BaseModalWindow>
    )
}